import { IClassNameProps } from '@bem-react/core';
import { useComponentRegistry } from '@bem-react/di';
import React, { PropsWithChildren, ReactNode, ReactNodeArray } from 'react';

import HtmlContent from 'client/common/components/html-content';
import cn from 'utils/cn';
import { getDate, humanizeDate } from 'utils/date';

import './index.css';

interface IMediaProps extends IClassNameProps {
    slug: string;
    title: string;
    dateString: string;
    description: string;
    keywords?: string;
    shareServices: string[];
    addonBefore?: ReactNode | ReactNodeArray;
}

const cnMedia = cn('media');

function Media({
    slug,
    keywords,
    title,
    dateString,
    description,
    shareServices,
    className,
    addonBefore,
    children }: PropsWithChildren<IMediaProps>) {
    const { YaShare } = useComponentRegistry('app');

    const date = getDate(dateString) as Date;
    const humanizedDate = humanizeDate(date, 'full');

    return (
        <div
            className={cnMedia({}, [className])}
            itemScope
            itemType="http://schema.org/Article"
            >
            <meta itemProp="identifier" content={slug} />
            {keywords && <meta itemProp="keywords" content={keywords} />}
            {addonBefore && (
            <div className={cnMedia('before')}>{addonBefore}</div>
            )}
            <h1
                className={cnMedia('title')}
                itemProp="headline"
                dangerouslySetInnerHTML={{ __html: title }}
                />
            <div className={cnMedia('line')}>
                <div className={cnMedia('date')}>
                    <time dateTime={date.toISOString()} itemProp="dateModified">
                        {humanizedDate}
                    </time>
                </div>
                <YaShare
                    id={'share-top'}
                    className={cnMedia('share')}
                    popup
                    size="m"
                    services={shareServices}
                    />
            </div>
            <HtmlContent
                className={cnMedia('description')}
                itemProp="description"
                content={description}
                />
            {children}
        </div>
    );
}

export default Media;
